/*eslint-disable*/
import React from "react";
import Image from "next/image"
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from '@mui/styles/makeStyles';

// @mui/icons-material
import Camera from "@mui/icons-material/Camera";
import Palette from "@mui/icons-material/Palette";

// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Parallax from "components/Parallax/Parallax.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Button from "components/CustomButtons/Button.js";
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";


import profilePageStyle from "styles/jss/nextjs-material-kit-pro/pages/profilePageStyle.js";

const useStyles = makeStyles(profilePageStyle);

export default function ProfilePage({ ...rest }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
  return (
    <div>
    <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        title="Robert Dzudzar - Tribalism"
        image="/img/examples/city-sm.webp"
        url="https://www.tribalism.com.au/about/profile-robert-dzudzar"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. Meet Robert Dzudzar, Tribalism's Executive Data Scientist !"

        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "info",
        }}
      />

      <Parallax
        image="/img/examples/city-sm.webp"
        filter="dark"
        className={classes.parallax}
      />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={6}>
              <div className={classes.profile}>
                <div>
                  <img
                    src="/img/faces/Robert-sq.webp"
                    alt="..."
                    className={imageClasses}
                  />
                
                </div>
                <div className={classes.name}>
                  <h3 className={classes.title}>Robert Dzudzar</h3>
                  <h6>Data Science Consultant</h6>
                  <a href = " https://twitter.com/robertdzudzar" target="_blank">
                  <Button
                    justIcon
                    simple
                    color="twitter"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-twitter"} />
                  </Button>
                  </a>
                  <a href = "https://au.linkedin.com/in/robertdzudzar" target="_blank">
                  <Button
                    justIcon
                    simple
                    color="linkedin"
                    
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-linkedin"} />
                  </Button>
                  </a>

                  <a href = "https://github.com/rdzudzar"  target="_blank">
                  <Button
                    justIcon
                    simple
                    color="github"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-github"} />
                  </Button>
                  </a>
                </div>
              </div>

            </GridItem>
          </GridContainer>
          <div className={classNames(classes.description, classes.textCenter)}>
            <p>
              Hi, I'm Robert. I love baking, science, watching tv shows, and I recently discovered that I love gaming - RPG in particular. 
              My background is in Science, in particular Astrophysics - happy to talk about the Universe at any given time :)
            </p>  
            <p>
              I love coding and developing tools, my moto is: be precise and make it beautiful. My love for data, their exploartion and 
              visualisation brought me to Tribalism. Here, I am using Google Tag Manager, Google Analytics and Google Data Studio to collect, analyse and visualise data, 
              in order to gain valuable insights and help our clients to achieve their goals.  
               {" "}
            </p>
          </div>
          <div className={classes.profileTabs}>
            <NavPills
              alignCenter
              color="primary"
              tabs={[
                {
                  tabButton: "Work",
                  tabIcon: Palette,
                  tabContent: ( 
                      
                    <GridContainer>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={7}
                        className={classes.gridItem}
                      >
                        <h4 className={classes.title}>Blog Posts</h4>
                        
                        <GridContainer className={classes.collections}>

                        <GridItem xs={12} sm={12} md={6}>
  <Card
    raised
    background
    style={{ backgroundImage: "url('/img/posts/2024-01-15-using-streamlit-to-build-web-applications/streamlit_header.png')" }}
  >
    <CardBody background>
      <h6 className={classes.category}>Development</h6>
      <a href="/blog-post/2024/01/using-streamlit-to-build-web-applications">
        <h3 className={classes.cardTitle}>
          Using Streamlit to Build Web Applications
        </h3>
      </a>
      <Button round href="/blog-post/2024/01/using-streamlit-to-build-web-applications" color="info">
        <FormatAlignLeft className={classes.icons} /> Read article
      </Button>
    </CardBody>
  </Card>
</GridItem>

<GridItem xs={12} sm={12} md={6}>
  <Card
    raised
    background
    style={{ backgroundImage: "url('/img/posts/2022-04-22-website-traffic-prediction/MultipleModels.png')" }}
  >
    <CardBody background>
      <h6 className={classes.category}>Analytics</h6>
      <a href="/blog-post/2022/04/website-traffic-prediction">
        <h3 className={classes.cardTitle}>
          Website Traffic Prediction
        </h3>
      </a>
      <Button round href="/blog-post/2022/04/website-traffic-prediction" color="success">
        <FormatAlignLeft className={classes.icons} /> Read article
      </Button>
    </CardBody>
  </Card>
</GridItem>

                          <GridItem xs={12} sm={12} md={6}>
                          <Card
                            raised
                            background
                            style={{ backgroundImage: "url('/img/posts/2022-01-06-URLFragments/url_backg.png')" }}
                          >
                            <CardBody background>
                              <h6 className={classes.category}>Other</h6>
                              <a href="/blog-post/2022/01/track-url-fragments-with-google-tag-manager">
                                <h3 className={classes.cardTitle}>
                                Track URL Fragments With Google Tag Manager (January 2022)
                                </h3>
                              </a>

                              <Button round href="/blog-post/2022/01/track-url-fragments-with-google-tag-manager" color="danger">
                                <FormatAlignLeft className={classes.icons} /> Read article
                              </Button>
                            </CardBody>
                          </Card>

                          </GridItem>
                         
                         
                        </GridContainer>
                      </GridItem>
                      
                    </GridContainer>
                    
                  ),
                },
                
                {
                  tabButton: "Media",
                  tabIcon: Camera,
                  tabContent: (
                    <GridContainer justifyContent="center">
                      <GridItem xs={12} sm={12} md={3}>
                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            quality={100}
                            width={255}
                            height={192}
                            alt="..."
                            src="/img/rob-photos/1.jpg"
                          />
                        </div>

                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            width={255}
                            height={340}
                            alt="..."
                            src="/img/rob-photos/2.jpg"

                          />
                        </div>


                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            quality={100}
                            width={255}
                            height={192}
                            alt="..."
                            src="/img/rob-photos/3.jpg"
                          />
                        </div>
                        


                      </GridItem>
                    </GridContainer>
                  ),
                },
              ]}
            />
          </div>
          <Clearfix />
        </div>
      </div>
      <Footer
        
      />
    </div>
  );
}
